import Store from "@/store/index";

import DebtReport from "@/pages/reports/debt/index";
import DocumentsReport from "@/pages/reports/documents/index";
import MedicalAnalysesReport from "@/pages/reports/medical-analyses/index";

import { userPermissionsList } from "@/constants/userPermissions";

export default [
    {
        path: "/debt-report",
        name: "debt-report",
        component: DebtReport,
        redirect: {
            name: "debt-employees-list",
        },
        children: [
            {
                path: "employees-list",
                name: "debt-employees-list",
                component: () => import("../../pages/reports/debt/components/table"),
                meta: {
                    title: "Отчет по остатку задолженности",
                },
            },
            {
                path: "reports",
                name: "debt-reports",
                component: () => import("../../pages/reports/debt/components/reports"),
                meta: {
                    title: "Отчет по остатку задолженности",
                },
            },
        ],
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = ["viewReportDebtBalance", "viewReportDebtBalanceAll"];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/documents-report",
        name: "documents-report",
        component: DocumentsReport,
        meta: {
            title: "Отчет по документам",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = ["viewDocumentsReport", "viewDocumentsReportForAllFilials"];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/medical-analyses-report",
        name: "medical-analyses-report",
        component: MedicalAnalysesReport,
        meta: {
            title: "Отчёт по анализам сотрудников",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = [
                    userPermissionsList.reports.medicalAnalyses.own,
                    userPermissionsList.reports.medicalAnalyses.all,
                ];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
